import React, { useState } from "react";

import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import {
  BooleanInput,
  StateSelect,
  CustomerSelect
} from "../../../components/inputs";
import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = { Active: true };

function LocationFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const newFilters = {
      ...inputs
    };
    if (e.target.name.includes("RecIdRef")) {
      const v = parseInt(value);
      newFilters[e.target.name] = v !== 0 ? v : null;
    } else {
      newFilters[e.target.name] = value;
    }
    setInputs(newFilters);
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <Label>Location ID</Label>
          <Input
            autocomplete="new"
            name="LocationID_contains"
            type="text"
            value={inputs.LocationID_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Location Name</Label>
          <Input
            autocomplete="new"
            name="LocationName_contains"
            type="text"
            value={inputs.LocationName_contains}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <CustomerSelect
            icon="user"
            label="Customer"
            name="BillToRecIdRef"
            value={inputs.BillToRecIdRef}
            variables={{
              orderByMulti: ["CustomerNo_ASC"]
            }}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>City</Label>
          <Input
            autocomplete="new"
            name="City_contains"
            type="text"
            value={inputs.City_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>State</Label>
          <StateSelect
            name="State"
            value={inputs.State}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Pickup</Label>
          <BooleanInput
            name="PickupLocation"
            value={inputs.PickupLocation}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Delivery</Label>
          <BooleanInput
            name="DeliveryLocation"
            value={inputs.DeliveryLocation}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
LocationFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default LocationFilters;
